const ModalTypeKeysGA = {
  ManageColumns: 'manage-columns',
  WidgetPreferences: 'widget-preferences',
  Permissions: 'permissions',
};

export default ModalTypeKeysGA;
